// extracted by mini-css-extract-plugin
export default {"buttons":"Modal_buttons__vWyob","cover_image":"Modal_cover_image__tzqUS"};